<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">Cidades</h6>
                <small class="card-subtitle">Informe as cidades desta região</small>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                        <th class="col-delete"></th> 
                        <th class="col-cidade">Cidade</th>
                        <th class="col-sub-regioes  text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-cidade">
                                <sgt-typeahead-cidade [(ngModel)]="entity.cidade" name="cidadeCidade" id="cidadeCidade"
                                    #cidadeCidade="ngModel" [ngControl]="cidadeCidade" #typeaheadCidade [dropup]="i >= 4"  
                                    (typeaheadChange)="onTypeaheadChangeCidade(entity, $event)">
                                </sgt-typeahead-cidade>                                
                            </td>
                            <td class="col-sub-regioes text-center">
                                <a class="btn btn-link" (click)="openSubRegioesModal(entity)" *ngIf="entity.cidade && entity.cidade.possuiSubRegioes">
                                   Sub-regiões
                                </a>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="3">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> <span class="d-none d-sm-inline-block">Adicionar Cidade</span>
                </button>
                <button type="button" class="btn btn-light btn-sm" (click)="openPopulaCidadeModal()">
                    <i class="fas fa-bolt" aria-hidden="true"></i> <span class="d-none d-sm-inline-block">Adicionar Várias Cidades</span>
                </button>
            </div>
        </div>        
    </div>
</div>

<!-- Modal para alterar as sub-regiões -->
<sgt-regiao-cidade-sub-regiao
    #regiaoCidadeSubRegiaoModal>
</sgt-regiao-cidade-sub-regiao>

<!-- Modal para popular as cidades -->
<sgt-regiao-cidade-popula-modal
    #regiaoCidadePopulaModal
    [entities]="entities">
</sgt-regiao-cidade-popula-modal>